// Internal Module Imports
import { BASE_URL_BIDDING_SERVICE } from '../../../constants';
import { HttpClient } from '../../../utils/httpClient';

const PATH = {
    post: `/${BASE_URL_BIDDING_SERVICE}/common/symetrical-bundle`,
    get: `/${BASE_URL_BIDDING_SERVICE}/common/symetrical-bundle`,
    put: `/${BASE_URL_BIDDING_SERVICE}/common/symetrical-bundle`,
    delete: `/${BASE_URL_BIDDING_SERVICE}/common/symetrical-bundle`,
};

const Create = (payload, start, callback, error, next) => {
    start();
    return HttpClient.post(`${PATH.post}`, payload).then(callback).catch(error).finally(next);
};

const Update = (id, payload, start, callback, error, next) => {
    start();
    return HttpClient.put(`${PATH.put}/${id}`, payload).then(callback).catch(error).finally(next);
};

const Get = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.get}`, { params }).then(callback).catch(error).finally(next);
};

const Delete = (id, start, callback, error, next) => {
    start();
    return HttpClient.delete(`${PATH.delete}/${id}`).then(callback).catch(error).finally(next);
};

export const SymetricalBundleService = {
    Create,
    Update,
    Get,
    Delete,
};
